import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from '../utils/mock';
import { UpdateExtractedField } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const updateExtractedField: MutationFunction<
  boolean,
  UpdateExtractedField
> = async (args) => {
  if (isMockServices()) {
    return await mock(true, {
      delay: 2000,
      failureRate: 0,
    });
  }

  // NOTE: encompassFields is intentionally excluded — the MOS extracted-data
  // endpoint does not accept it ("is not allowed"). LOS/Encompass values are
  // pushed separately via the external-fields endpoint (setExternalFieldsByLoan).
  const updatingFields = args.fields
    .map((field) => ({
      id: field.id,
      fieldTypeId: field.fieldTypeId,
      fieldValue: field.fieldValue,
      manuallyCorrected: field.manuallyCorrected,
      userApproved: field.userApproved,
      boundingBoxes: field.boundingBoxes,
      fieldConfidence: field.fieldConfidence,
      tableValue: field.tableValue,
      pageId: field.pageId,
    }))
    .map((field) => {
      const {
        id,
        fieldTypeId,
        fieldValue,
        fieldConfidence,
        manuallyCorrected,
        userApproved,
        tableValue,
        boundingBoxes,
        pageId,
      } = field;
      if (id == undefined || id === '') {
        return {
          fieldTypeId,
          fieldValue,
          fieldConfidence,
          manuallyCorrected,
          userApproved,
          tableValue,
          boundingBoxes,
          pageId,
        };
      } else {
        return {
          id,
          fieldTypeId,
          fieldValue,
          fieldConfidence,
          manuallyCorrected,
          userApproved,
          tableValue,
          boundingBoxes,
          pageId,
        };
      }
    });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<boolean>(
    `/extractedData/documents/${args.documentId}`,
    {
      method: 'PUT',
      body: updatingFields,
    },
  );

  if (response.data) return response.data;

  throw new Error('Failed to update extracted field');
};

export default updateExtractedField;
